import * as React from "react";

import { WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";

import { Button, FS, Text } from "../components";

type ClassNames = "container";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    container: {
        alignItems: "center",
        display: "flex",
        justifyContent: "center"
    }
});

class PageNotFound extends React.Component<WithStyles<ClassNames> & {}> {
    public render() {
        const {classes} = this.props;
        return (
            <FS className={classes.container}>
                <Text variant="title3" color="inherit">Page not found</Text>
                <Button href="/" primary={true}>
                    Take me home
                </Button>
            </FS>
        );
    }
}

export default withStyles(styles)(PageNotFound);



// WEBPACK FOOTER //
// ./src/page-not-found/PageNotFound.tsx